export class OrderPaymentCreateResponse {
    public confirmationToken: string;

    constructor(data?: Partial<OrderPaymentCreateResponse>) {
        this.confirmationToken = data?.confirmationToken;
    }
}
